var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":'/quick-support'}},[_c('img',{staticClass:"quick-support",attrs:{"src":require("@/assets/quicksupport_ad.svg"),"alt":"Quick-Support logo","title":"AnyDesk Quick-Support"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }